export default __webpack_public_path__ + "static/media/case01.162144de.png";